import React from 'react';
import womanPhone from '../../images/account/woman-phone-grouped@3x.png';
import getHelpIcon from '../../images/account/icon-get-help.svg';
import videoCallIcon from '../../images/account/icon-video-call.svg';
import connectToVetIcon from '../../images/account/icon-connect-to-vet.svg';
import blogImage1 from '../../images/account/BlogImage1.png';
import blogImage2 from '../../images/account/BlogImage2.png';
import blogImage3 from '../../images/account/BlogImage3.png';

export const ACTIVE_STATUS = 'Active';

export const ADD_PET_FLOW_KEY = 'ADD_PET_FLOW';

export const ADD_PET_SUBSCRIPTION_KEY = 'ADD_PET_SUBSCRIPTION';

export const HEADLINE = 'Welcome back, {{name}}!';
export const SUBHEADLINE =
  'Keep tabs on your subscription and edit info for {{petName}}.';
export const DOG_SELECTOR_LABEL = 'View info for:';
export const ADD_PUP_BTN_URL = 'account/add-pup';
export const ADD_PUP_BTN_LABEL = 'Add another pup';
export const YOUR_PUP = {
  title: 'Your pup',
  image: {
    src: 'https://a.storyblok.com/f/89894/102x110/81f1273ac8/petting-dog.png',
    alt: 'doggo',
    width: 500,
    height: 300,
  },
  buttonUrlTarget: '/account/edit-pup',
  buttonLabel: "Edit pup's details",
  reactivateButtonLabel: 'Reactivate membership now',
  hasActiveSubscription: true,
  reactivateUrlTarget: '/account/reactivate-pup/summary',
  feedingGuidelinesLabel: 'View {{pupName}}’s feeding guidelines',
  inactiveMembershipText: 'Membership inactive',
};

export const EMPTY_PET = {
  breeds: [],
  allergies: [],
  name: '',
};

export const BOX_MANAGEMENT_NAV = {
  label: 'Manage {{pupName}}’s box',
  shippingDate: ['June 16, 2021'],
  frequency: ['Every 2 weeks'],
  shippingInfo: ['Kyle Mitchell', '62 Pine Hill Rd', 'Southborough, MA 01772'],
  paymentInfo: [
    'Card: •••• •••• •••• 1234',
    'Billing zip: 12136',
    'Exp. 3/12/23',
  ],
  product: {
    variable: 'mix',
    recipes: {
      dry: ['Beef', 'Chicken'],
      fresh: ['Beef', 'Chicken', 'Lamb', 'Turkey'],
    },
  },
  mealPrep: ['A mixed bowl'],
};

export const BOX_MANAGEMENT_NAV_NO_PAYMENT_METHOD = {
  label: 'Manage {{pupName}}’s box',
  shippingDate: ['June 16, 2021'],
  frequency: ['Every 2 weeks'],
  shippingInfo: ['Kyle Mitchell', '62 Pine Hill Rd', 'Southborough, MA 01772'],
  paymentInfo: [],
  product: {
    variable: 'mix',
    recipes: {
      dry: ['Beef', 'Chicken'],
      fresh: ['Beef', 'Chicken', 'Lamb', 'Turkey'],
    },
  },
  mealPrep: ['A mixed bowl'],
};

export const VET_SERVICES = {
  bodyText: (
    <>
      Talk to an OllieHealth Expert and get the answers you need.
      <br />
      Start a live chat or schedule a video call.
    </>
  ),
  ctaButtonText: 'Click to learn more',
  heroTitle: 'A free member exclusive',
  image: {
    src: womanPhone,
    alt: 'video chat with a vet',
    layout: 'fill',
    objectFit: 'contain',
  },
  title: 'Try OllieHealth',
};

export const VET_SERVICES_URL = '/api/v3/vetservices/';

const VET_SERVICES_MODAL_CTA_BUTTON_TEXT = 'Talk to a Vet Professional';

export const VET_SERVICES_ERROR = 'Unable to connect to Teletails.';

export const VET_SERVICES_MODAL = {
  ctaButtonText: VET_SERVICES_MODAL_CTA_BUTTON_TEXT,
  headline: 'Free expert veterniary advice at your fingertips',
  items: [
    {
      icon: connectToVetIcon.src,
      iconAltText: 'vet',
      heading: 'Get connected to a Vet Professional',
      text:
        'Have a burning question about your pup’s health? We’ll set you up with one of our experienced vet technicians.',
    },
    {
      icon: videoCallIcon.src,
      iconAltText: 'hand holding phone',
      heading: 'Video call or live chat',
      text:
        'Schedule a video consultation in advance or hop into a live chat to connect insantly.',
    },
    {
      icon: getHelpIcon.src,
      iconAltText: 'building with medical plus symbol',
      heading: 'Get the help you need',
      text:
        'Feel confident and empowered to care for your pup by working with licensed professionals.',
    },
  ],
  disclaimer: `By clicking ${VET_SERVICES_MODAL_CTA_BUTTON_TEXT} you will be leaving Ollie’s website and
          redirected to the Teletails web experience. Any use of Teletails’s
          website and services will be subject to their terms of service and
          privacy policy. Please note that Ollie is not responsible, and
          expressly disclaims all liability, for the information, content or
          services found and purchased on Teletails’s website.`,
};

export const BLOGS = [
  {
    topic: 'DOG NUTRITION',
    title: {
      position: 'left',
      typography: 'body',
      headingText: 'The 10 Best Ingredients for Dogs',
      headingLevel: 'h6',
    },
    date: '21.JUN.2021',
    image: {
      src: blogImage1,
      alt: 'nicely plated fresh ingredients on a pink tablecloth',
      width: 335,
      height: 190,
    },
    blogLink: 'https://blog.myollie.com/10-healthiest-dog-food-ingredients/',
    backgroundColor: 'background.lightest',
  },
  {
    topic: 'TRAINING ADVICE',
    title: {
      position: 'left',
      typography: 'body',
      headingText: 'What to Do if Your Dog Eats Too Fast and Then Throws Up',
      headingLevel: 'h6',
    },
    date: '28.FEB.2021',
    image: {
      src: blogImage2,
      alt: 'doggo eating their food with great enthusiasm and speed',
      width: 335,
      height: 190,
    },
    blogLink:
      'https://blog.myollie.com/how-to-slow-down-a-dog-who-eats-too-fast/',
    backgroundColor: 'background.lightest',
  },
  {
    topic: 'DOG HEALTH',
    title: {
      position: 'left',
      typography: 'body',
      headingText: "What your Dog's Poop Says About Their Health",
      headingLevel: 'h6',
    },
    date: '20.MAY.2021',
    image: {
      src: blogImage3,
      alt:
        'drawing of dog waste bag dispenser with the words "Party Pooper" written on it',
      width: 335,
      height: 190,
    },
    blogLink:
      'https://blog.myollie.com/what-your-dogs-poop-says-about-their-health/',
    backgroundColor: 'background.lightest',
  },
];
